module.exports = __webpack_public_path__ + "img/AL12X1-1.b9968c58.png";